import type { FC } from 'react'
import { VISIT } from 'screens/Rostering/constants'
import { NeedsAssignedSection, SkillsRequiredSection } from '../sections'
import type { ModalSectionProps, RotaPatternModalType } from '../utils'

export const SkillsTagsStep: FC<
  ModalSectionProps & { type?: RotaPatternModalType }
> = ({ type, formData }) => {
  return (
    <>
      {type === VISIT && <NeedsAssignedSection formData={formData} />}
      <SkillsRequiredSection type={type} formData={formData} />
    </>
  )
}
